export var EnergyDeviceType;
(function (EnergyDeviceType) {
    EnergyDeviceType["ENERGY_BAR"] = "ENERGY_BAR";
    EnergyDeviceType["ENERGY_SPIDER"] = "ENERGY_SPIDER";
    EnergyDeviceType["ENERGY_SPIDER_FLEX"] = "ENERGY_SPIDER_FLEX";
    EnergyDeviceType["UNASSIGNED"] = "";
})(EnergyDeviceType || (EnergyDeviceType = {}));
export var EnergyDevicePorts;
(function (EnergyDevicePorts) {
    EnergyDevicePorts[EnergyDevicePorts["Energy Bar"] = 6] = "Energy Bar";
    EnergyDevicePorts[EnergyDevicePorts["Energy Spider"] = 8] = "Energy Spider";
    EnergyDevicePorts[EnergyDevicePorts["Energy Spider Flex"] = 4] = "Energy Spider Flex";
    EnergyDevicePorts[EnergyDevicePorts["EnergyBar"] = 6] = "EnergyBar";
    EnergyDevicePorts[EnergyDevicePorts["EnergySpider"] = 8] = "EnergySpider";
    EnergyDevicePorts[EnergyDevicePorts["EnergySpider2"] = 6] = "EnergySpider2";
    EnergyDevicePorts[EnergyDevicePorts["EnergySpiderFlex"] = 4] = "EnergySpiderFlex";
    EnergyDevicePorts[EnergyDevicePorts["ENERGY_BAR"] = 6] = "ENERGY_BAR";
    EnergyDevicePorts[EnergyDevicePorts["ENERGY_SPIDER"] = 8] = "ENERGY_SPIDER";
    EnergyDevicePorts[EnergyDevicePorts["ENERGY_SPIDER_FLEX"] = 4] = "ENERGY_SPIDER_FLEX";
    EnergyDevicePorts[EnergyDevicePorts["EnergyPro"] = 3] = "EnergyPro";
})(EnergyDevicePorts || (EnergyDevicePorts = {}));
